// Custom navigation fix for product modals
// This script fixes the navigation from Descripción drawer to open Guía de tallas instead of Dream Tomorrow

document.addEventListener('DOMContentLoaded', function() {
    // Wait a bit for all modals to be initialized
    setTimeout(function() {
        // Find the Descripción modal (modal-5)
        const descripcionModal = document.querySelector('dialog[data-maje-modal="maje-product-modal-5"]');
        const dreamTomorrowModal = document.querySelector('dialog[data-maje-modal="maje-product-modal-6"]');
        
        if (descripcionModal) {
            // Find the next button in the Descripción modal
            const nextButton = descripcionModal.querySelector('button.maje-product-modal__next');
            
            if (nextButton) {
                // Remove existing event listeners by cloning the button
                const newNextButton = nextButton.cloneNode(true);
                nextButton.parentNode.replaceChild(newNextButton, nextButton);
                
                // Add new click handler
                newNextButton.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Close the Descripción modal
                    descripcionModal.close();
                    document.body.style.overflow = 'auto';
                    
                    // Find and trigger the actual Guía de tallas button
                    // The Avada-SC-button is the actual clickable element for the size chart
                    const avadaButton = document.querySelector('.Avada-inline-button');
                    
                    if (avadaButton) {
                        // Click the Avada button directly - this should trigger the size chart modal
                        avadaButton.click();
                    } else {
                        // If Avada button not found, try to find any element with "Guía de tallas" text
                        // and click its parent container
                        const allElements = document.querySelectorAll('*');
                        for (let el of allElements) {
                            // Look for the span element that contains "Guía de tallas"
                            if (el.textContent && el.textContent.trim() === 'Guía de tallas' && 
                                !el.querySelector('*')) {
                                // Try clicking the parent element (which should be the button)
                                if (el.parentElement && el.parentElement.id !== 'Avada-SC-button') {
                                    // This is likely the span inside our drawer, skip it
                                    continue;
                                }
                                // Click the parent element
                                if (el.parentElement) {
                                    el.parentElement.click();
                                    break;
                                }
                            }
                        }
                    }
                });
                
                // Update the button text to show "Guía de tallas"
                const buttonTextSpan = newNextButton.querySelector('span');
                if (buttonTextSpan) {
                    buttonTextSpan.textContent = 'Guía de tallas';
                }
            }
        }
        if (dreamTomorrowModal) {
            const prevButton = dreamTomorrowModal.querySelector('button.maje-product-modal__prev');

            if (prevButton) {
                // Remove existing event listeners by cloning the button
                const newPrevButton = prevButton.cloneNode(true);
                prevButton.parentNode.replaceChild(newPrevButton, prevButton);
                
                // Add new click handler
                newPrevButton.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    
                    // Close the Dream Tomorrow modal
                    dreamTomorrowModal.close();
                    document.body.style.overflow = 'auto';
                    
                    // Find and trigger the actual Descripción button
                    const avadaButton = document.querySelector('.Avada-inline-button');
                    
                    if (avadaButton) {
                        // Click the Avada button directly - this should trigger the size chart modal
                        avadaButton.click();
                    }
                });
                
                // Update the button text to show "Descripción"
                const buttonTextSpan = newPrevButton.querySelector('span');
                if (buttonTextSpan) {
                    buttonTextSpan.textContent = 'Guía de tallas';
                }
            }
        }
    }, 500); // Wait 500ms for modal initialization
});